import { Field, Formik, Form } from 'formik'; // Make sure to import Formik and Form
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardHeader, Col, Container, FormGroup, Label, Row } from 'reactstrap';
import ButtonSection from './ButtonSection';
import { useNavigate, useParams } from 'react-router-dom';

function WhileLabelSection() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();

    // 1. Define initial values for Formik
    const initialValues = {
        CRMUrl: "",
        LinkHubURL: "",
        PinterestURL: "",
        LinkedInURL: "",
        FacebookURL: "",
        InstagramURL: "",
        QuoraURL: "",
        YouTubeURL: "",
        TwitterURL: "",
        ERPUrl: "",
        ServiceURL: "",
    };

    // 2. Define the submit handler for Formik
    const handleSubmit = (values:any) => {
        // This function is called on successful submission
        // The default form submission (which causes the URL change) is prevented.
        console.log("Form submitted with values:", values);
        // Add your API call logic here
        // For example: api.updateOrganization(id, values);
        navigate("/masterdata/organization");
    };

    const handleClose = () => {
        navigate("/masterdata/organization");
    };

    return (
        <Container fluid={true}>
            <div className="container-...">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                            
                                <Formik
                                    initialValues={initialValues}
                                    onSubmit={handleSubmit}
                                >
                                    {() => (
                                        // 4. Use Formik's Form component
                                        <Form className="theme-form">
                                          
                                            <Row className="g-3">
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>{t("CRMURL")}</Label>
                                                        <Field
                                                            name="CRMUrl"
                                                            type="text"
                                                            placeholder={t("EnterCRMURL")}
                                                            className="form-control"
                                                        />
                                                    </FormGroup>
                                                </Col>
                                             
                                                <Col sm="6">
                                                  <FormGroup>
                                                    <Label>{t("LinkHubURL")}</Label>
                                                    <Field
                                                      name="LinkHubURL"
                                                      type="text"
                                                      placeholder={t("EnterLinkHubURL")}
                                                      className="form-control"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                  <FormGroup>
                                                    <Label>{t("PinterestURL")}</Label>
                                                    <Field
                                                      name="PinterestURL"
                                                      type="text"
                                                      placeholder={t("EnterPinterestURL")}
                                                      className="form-control"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                  <FormGroup>
                                                    <Label>{t("LinkedInURL")}</Label>
                                                    <Field
                                                      name="LinkedInURL"
                                                      type="text"
                                                      placeholder={t("EnterLinkedInURL")}
                                                      className="form-control"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                  <FormGroup>
                                                    <Label>{t("FacebookURL")}</Label>
                                                    <Field
                                                      name="FacebookURL"
                                                      type="text"
                                                      placeholder={t("EnterFacebookURL")}
                                                      className="form-control"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                  <FormGroup>
                                                    <Label>{t("InstagramURL")}</Label>
                                                    <Field
                                                      name="InstagramURL"
                                                      type="text"
                                                      placeholder={t("EnterInstagramURL")}
                                                      className="form-control"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                  <FormGroup>
                                                    <Label>{t("QuoraURL")}</Label>
                                                    <Field
                                                      name="QuoraURL"
                                                      type="text"
                                                      placeholder={t("EnterQuoraURL")}
                                                      className="form-control"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                  <FormGroup>
                                                    <Label>{t("YouTubeURL")}</Label>
                                                    <Field
                                                      name="YouTubeURL"
                                                      type="text"
                                                      placeholder={t("EnterYouTubeURL")}
                                                      className="form-control"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                  <FormGroup>
                                                    <Label>{t("TwitterURL")}</Label>
                                                    <Field
                                                      name="TwitterURL"
                                                      type="text"
                                                      placeholder={t("EnterTwitterURL")}
                                                      className="form-control"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                  <FormGroup>
                                                    <Label>{t("ERPURL")}</Label>
                                                    <Field
                                                      name="ERPUrl"
                                                      type="text"
                                                      placeholder={t("EnterERPURL")}
                                                      className="form-control"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                  <FormGroup>
                                                    <Label>{t("ServiceURL")}</Label>
                                                    <Field
                                                      name="ServiceURL"
                                                      type="text"
                                                      placeholder={t("EnterServiceURL")}
                                                      className="form-control"
                                                    />
                                                  </FormGroup>
                                                </Col>
                                            </Row>
                                         
                                         </Form>
                                    )}
                                </Formik>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </Container>
    );
}

export default WhileLabelSection;